import jwtDecode from 'jwt-decode';

import { NODE_ENV } from '@config/env';

import { AuthDecodedToken } from '@types';

export { default as debounce } from 'lodash/debounce';

export const isProduction = (): boolean => {
  return NODE_ENV === 'production';
};

export const wait = (ms: number): Promise<void> => {
  return new Promise((resolve: () => void) => setTimeout(resolve, ms));
};

export const decodeAuthToken = (
  encodedToken: undefined | string
): undefined | AuthDecodedToken => {
  if (!encodedToken) {
    return;
  }

  return jwtDecode<AuthDecodedToken>(encodedToken);
};

export const shouldNotForwardProps =
  (propNames: string[]) =>
  (propName: string | number | symbol): boolean =>
    !propNames.includes(propName.toString());

export const shouldForwardProp = <CustomProps extends Record<string, unknown>>(
  props: (keyof CustomProps)[],
  prop: PropertyKey
): boolean => !props.includes(prop as string);

export const scrollToTop = (options?: ScrollToOptions): void => {
  window.scrollTo({
    top: 0,
    left: 0,
    ...options,
  });
};

export const scrollIntoView = (
  element?: null | HTMLDivElement,
  options?: ScrollIntoViewOptions
): void => {
  element?.scrollIntoView(options);
};
